/** @format */

import { Paper, Grid, Typography, Backdrop } from '@mui/material';
import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { useStyles } from './Style';
import { Icons } from 'components';

export default function UploadDoc({ file, setFile, disabled }) {

  const onDrop = useCallback((acceptedFiles) => {
    setFile(acceptedFiles[0]);
  }, []);

  // --HOOKS--//
  const classes = useStyles();
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  return (
    <Paper className={classes.uploadPaper} elevation={0}>
      <Backdrop open={disabled} className={classes.backdrop} />
      <div {...getRootProps()}>
        <input
          {...getInputProps()}
          multiple={false}
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        />
        <Grid justifyContent="center" container direction="column" item xs={12}>
          <Grid justifyContent="center" container item xs={12}>
            {file ? (
              <Typography className={classes.fileFormat} variant="h5" align="center">
                {`.${file?.name?.split('.').pop()}`}
              </Typography>
            ) : isDragActive ? (
              <span className={classes.dragHereIcon}>
                <Icons icon="plusCircle" color="#2B3990" size="20" />
              </span>
            ) : (
              <span className={classes.dragHereIcon}>
                <Icons icon="NoteAdd" color="#2B3990" size="20" />
              </span>
            )}
          </Grid>
          <Grid justifyContent="center" container item xs={12}>
            <Typography className={classes.dragHereText} variant="h5" align="center">
              {file
                ? file?.name
                : isDragActive
                  ? 'فایل را اینجا رها کنید'
                  : 'فایل  xlsx. را به اینجا بکشید یا انتخاب کنید'}
            </Typography>
          </Grid>
        </Grid>
      </div>
    </Paper>
  );
}

